import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
import _ from "../Trans";

const defaultSeeMoreText = _('See more');
const defaultSeePreviousText = _('Previous')

const LessButton = function ({requestPrevious, seePreviousText}) {
    if (seePreviousText === null || seePreviousText === undefined) {
        seePreviousText = defaultSeePreviousText;
    }
    return (
        <div className="minileague-less">
            <span onClick={requestPrevious} className="link">
                <FontAwesomeIcon icon={faChevronUp}/>
                <span className="minileague-chevron-separation">
                    {seePreviousText}
                </span>
                <FontAwesomeIcon icon={faChevronUp}/>
            </span>
        </div>
    )
}

const MoreButton = function ({requestMore, seeMoreText}) {
    if (seeMoreText === null || seeMoreText === undefined) {
        seeMoreText = defaultSeeMoreText;
    }
    return (
        <div className="minileague-more">
            <span onClick={requestMore} className="link">
                <FontAwesomeIcon icon={faChevronDown}/>
                <span className="minileague-chevron-separation">
                    {seeMoreText}
                </span>
                <FontAwesomeIcon icon={faChevronDown}/>
            </span>
        </div>
    )
}

export {MoreButton, LessButton};